module.exports = __webpack_public_path__ + "img/sld_scb_5_t1_green.082c862b.svg";